import { render, staticRenderFns } from "./i-head.vue?vue&type=template&id=1e6f74e7&scoped=true&"
import script from "./i-head.vue?vue&type=script&lang=js&"
export * from "./i-head.vue?vue&type=script&lang=js&"
import style0 from "./i-head.vue?vue&type=style&index=0&id=1e6f74e7&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6f74e7",
  null
  
)

export default component.exports